import React, { useEffect } from "react";
import ApplicationChecklistComponentLegacy from "../../../components/applicationComponents/legacy/applicationChecklist/ApplicationChecklistComponentLegacy";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function ApplicationChecklistPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Type of Application",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <ApplicationChecklistComponentLegacy disabled={false} />
    </>
  );
}
